// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__2H1uG","progress_wrapper":"Question_progress_wrapper__1acIV","quiz_image_wrapper":"Question_quiz_image_wrapper__1E2jx"};